import React from "react";

const Stepper = ({ totalSteps, currentStep }) => {
  return (
    <div
      style={{
        display: "flex",
        gap: "8px",
        width: "100%",
      }}
    >
      {Array.from({ length: totalSteps }, (_, index) => {
        const stepNumber = index + 1;
        const isCompleted = stepNumber <= currentStep;

        return (
          <div
            key={stepNumber}
            style={{
              width: "32px",
              height: "32px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRadius: "50%",
              border: "2px solid #1e88e5",
              color: isCompleted ? "white" : "#1e88e5",
              backgroundColor: isCompleted ? "#1e88e5" : "transparent",
              fontWeight: "bold",
            }}
          >
            {stepNumber}
          </div>
        );
      })}
    </div>
  );
};

export default Stepper;
